import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchPlateforms = async () => {
  const res = await axios.get(`${API_URL}/plateforms`, header());
  return res.data;
};

export const fetchPlateform = async (id) => {
  const res = await axios.get(`${API_URL}/plateforms/${id}`, header());
  return res.data;
};

export const fetchPlateformsByStore = async (storeId) => {
  if (!storeId) {
    throw new Error('storeId is required to fetch plateforms by store.');
  }

  const res = await axios.get(`${API_URL}/plateforms/store/${storeId}`, header());
  return res.data;
};

export const createPlateform = async (data) => {
  const res = await axios.post(`${API_URL}/plateforms`, data, header());
  return res.data;
};

export const updatePlateform = async (id, data) => {
  const res = await axios.put(`${API_URL}/plateforms/${id}`, data, header());
  return res.data;
};

export const deletePlateform = async (id) => {
  await axios.delete(`${API_URL}/plateforms/${id}`, header());
};

export const testGlovoConnection = async (data = {}) => {
  const res = await axios.post(`${API_URL}/glovo/login/test`, data, header());
  return res.data;
};

export const testKooulConnection = async (data = {}) => {
  const res = await axios.post(`${API_URL}/kooul/test-login`, data, header());
  return res.data;
};

export const syncKooulCategories = async (data = {}) => {
  const res = await axios.post(
    `${API_URL}/kooul/sync-categories`,
    data,
    header()
  );
  return res.data;
};

export const syncKooulAllProducts = async (data = {}) => {
  const res = await axios.post(
    `${API_URL}/kooul/sync_all_product`,
    data,
    header()
  );
  return res.data;
};

export const syncKooulOrders = async (data = {}) => {
  const res = await axios.post(`${API_URL}/kooul/orders/sync`, data, header());
  return res.data;
};

export const syncKooulCategoryProducts = async (data = {}) => {
  // Use legacy underscore endpoint for Kooul per-category sync
  const underscoreUrl = `${API_URL}/kooul/sync_category_products`;
  const res = await axios.post(underscoreUrl, data, header());
  return res.data;
};

export const syncMarjaneMallOrders = async (data = {}) => {
  const res = await axios.post(`${API_URL}/marjanemall/orders/sync`, data, header());
  return res.data;
};

export const syncMarjaneMallOrdersByDate = async (data = {}) => {
  const res = await axios.post(`${API_URL}/marjanemall/orders/sync-bydate`, data, header());
  return res.data;
};

export const submitKooulOrderDecision = async (data = {}) => {
  const res = await axios.post(`${API_URL}/kooul/orders/accept-reject`, data, header());
  return res.data;
};

const withDefaultPlateformName = (data = {}) => {
  const payload = { plateform_name: 'aimer.ma', ...data };
  if (!payload.plateform_name && !payload.plateformName) {
    payload.plateform_name = 'aimer.ma';
  }
  return payload;
};

export const loginAimer = async (data = {}) => {
  const payload = withDefaultPlateformName(data);
  const res = await axios.post(`${API_URL}/aimer/login`, payload, header());
  return res.data;
};

export const fetchAimerProduct = async (productId, params = {}) => {
  if (!productId) {
    throw new Error('Product ID is required to fetch an aimer.ma product.');
  }

  const config = header();
  if (params && Object.keys(params).length > 0) {
    config.params = params;
  }

  const res = await axios.get(
    `${API_URL}/aimer/products/${encodeURIComponent(productId)}`,
    config
  );
  return res.data;
};

export const fetchAimerVendorProducts = async (params = {}) => {
  const config = header();
  if (params && Object.keys(params).length > 0) {
    config.params = params;
  }

  const res = await axios.get(`${API_URL}/aimer/vendor-products`, config);
  return res.data;
};

export const syncAimerVendorCategories = async () => {
  const res = await axios.get(`${API_URL}/aimer/vendor-categories`, header());
  return res.data;
};

export const createAimerProduct = async (productId, data = {}) => {
  if (!productId) {
    throw new Error('Product ID is required to create an Aimer product.');
  }

  const payload = withDefaultPlateformName(data);
  const res = await axios.post(
    `${API_URL}/aimer/products/${encodeURIComponent(productId)}/create`,
    payload,
    header()
  );
  return res.data;
};

export const changeAimerProductStatus = async (productId, data = {}) => {
  if (!productId) {
    throw new Error('Product ID is required to change an Aimer product status.');
  }

  const payload = withDefaultPlateformName(data);
  const res = await axios.post(
    `${API_URL}/aimer/products/${encodeURIComponent(productId)}/status`,
    payload,
    header()
  );
  return res.data;
};

export const linkProductToPlateform = async (productId, data = {}) => {
  if (!productId) {
    throw new Error('Product ID is required to link a plateform.');
  }

  const res = await axios.patch(
    `${API_URL}/products/${productId}/plateform`,
    data,
    header()
  );
  return res.data;
};

export default {
  fetchPlateforms,
  fetchPlateform,
  fetchPlateformsByStore,
  createPlateform,
  updatePlateform,
  deletePlateform,
  testGlovoConnection,
  testKooulConnection,
  syncKooulCategories,
  syncKooulAllProducts,
  syncKooulCategoryProducts,
  syncKooulOrders,
  syncMarjaneMallOrders,
  syncMarjaneMallOrdersByDate,
  submitKooulOrderDecision,
  loginAimer,
  fetchAimerProduct,
  fetchAimerVendorProducts,
  syncAimerVendorCategories,
  createAimerProduct,
  changeAimerProductStatus,
  linkProductToPlateform,
};
